<template>
  <v-expansion-panels accordion
                      v-model="openPanelIndex"
                      class="elevation-0 mb-4">
    <v-expansion-panel>

      <v-expansion-panel-header>
        <span v-if="plannedServiceDTO">{{ $t('plannedService.singular') }}: {{plannedServiceDTO.plannedService.name}} </span>
        <span v-if="defectReportDTO">{{ $t('defectReport.singular') }}: {{defectReportDTO.defectReport.title}} </span>
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <v-container >
          <planned-service-properties-view v-if="plannedServiceDTO"
                                           :planned-service="plannedServiceDTO.plannedService"
                                           :documents="plannedServiceDTO.documents"/>

          <defect-report-properties-view v-if="defectReportDTO"
                                         :defect-report="defectReportDTO.defectReport"
                                         :documents="defectReportDTO.documents"/>
        </v-container>
        <v-btn v-if="isMobileLayout"
               block
               depressed
               x-small
               class="mt-3"
               @click="close">
          <v-icon>mdi-chevron-up</v-icon>
        </v-btn>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
import PlannedServicePropertiesView from '@/views/plannedService/PlannedServicePropertiesView';
import DefectReportPropertiesView from '@/views/defectreport/DefectReportPropertiesView';
export default {
  name: 'ServiceOrderView',
  components: { DefectReportPropertiesView, PlannedServicePropertiesView },
  props: {
    plannedServiceDTO: { type: Object },
    defectReportDTO: { type: Object },
  },

  data() {
    return {
      openPanelIndex: 0,
    };
  },
  computed: {
    expanded() {
      return this.openPanelIndex === 0;
    },
    isMobileLayout() {
      return this.$vuetify.breakpoint.name === 'xs';
    },
  },
  methods: {
    close() {
      this.openPanelIndex = null;
    },
  },
  created() {
    this.openPanelIndex = null; //defaulting to closed
  },

};
</script>

<style scoped>

</style>
